module.exports = __webpack_public_path__ + "img/tm-2.de15cbf6.png";